/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Models */
import { BydModel } from '@sixense/byd-core-service';
import { DsMonthlyTimeChartData } from './classes/monthly-time-chart-data.class';
/** Services */
import { BydRhsAbstractService } from '../../shared/services/byd-rhs-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class DsMonthlyDashboardService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get history of active/inactive users, limited to last 12 months by default.
   *
   * @param projectId Current project id
   * @returns Observable<BydModel<DsMonthlyTimeChartData>>
   */
  public getProjectUsersHistory(projectId: number): Observable<BydModel<DsMonthlyTimeChartData>> {
    this.path = `/projects/${projectId}/users/monthlycount`;
    return this.getModels<DsMonthlyTimeChartData>();
  }

  /**
   * Create DsMonthlyTimeChartData instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsMonthlyTimeChartData` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): DsMonthlyTimeChartData {
    return new DsMonthlyTimeChartData(jsonObject);
  }
}
